// Thin, safe wrapper around the Meta (Facebook) Pixel.
// The global `fbq` is loaded by the base pixel snippet in index.html.

export function track(event, params = {}, options) {
	if (typeof window === "undefined" || typeof window.fbq !== "function")
		return;
	window.fbq("track", event, params, options);
}

// Fires a standard Purchase event with:
//   value       -> plaćeni iznos (paid amount)
//   currency    -> currency of the amount
//   plan        -> plan code (WK/MO/QU/YR); sent as content_ids
//   planName    -> tip plana (readable plan type); sent as content_name
//   orderId     -> broj narudžbe (order number); sent as order_id
// `eventID` (defaults to orderId) lets Meta de-duplicate if you later add
// the server-side Conversions API.
export function trackPurchase({
	value,
	currency,
	plan,
	planName,
	orderId,
} = {}) {
	track(
		"Purchase",
		{
			value: Number(value),
			currency,
			content_type: "product",
			...(plan ? { content_ids: [plan] } : {}),
			...(planName ? { content_name: planName } : {}),
			...(orderId ? { order_id: orderId } : {}),
		},
		orderId ? { eventID: String(orderId) } : undefined
	);
}
